import { createAction, props } from "@ngrx/store";
import { EditingTextState } from "../State/editingTexteState";

export const setEditingTextInputs = createAction(
  '[EditingText] Set Inputs',
  props<{ inputs: Partial<EditingTextState> }>()
);

export const emitParameter = createAction(
  '[EditingText] Emit Parameter',
  props<{ payload: any; index: number; origin: 'title' | 'url' | 'button' | 'subtitle' }>()
);

export const emitEmoji = createAction(
  '[EditingText] Emit Emoji',
  props<{ emoji: string; index: number }>()
);

export const emitPersonolization = createAction(
  '[EditingText] Emit Personolization',
  props<{ data: any; index: number }>()
);
